export default __webpack_public_path__ + "static/RAF-4e53d017e7b68134046c13110c2bd591.jpg";